<template>
  <div class="fill-height">
    <v-skeleton-loader v-if="loading" type="card" class="w-100" />
    <v-card v-else class="rounded-xl card-border-red h-100 pa-4">
      <div class="fill-height align-center justify-center pa-2">
        <!-- user info -->
        <div class="d-flex flex-column">
          <div class="align-self-center mx-4">
            <span class="font-weight-bold small"
              >{{ data.channelDesc | capitalizeFirstLetter }}
            </span>
            <br />
            <span v-if="isRM" class="small">
              ({{ `${data.zoneId} - ${data.zoneFullDesc}` }})
            </span>
          </div>
        </div>
        <p class="my-3">({{ data.user.id }}) {{ data.user.name }}</p>

        <!-- end user info -->
        <div class="d-flex">
          <div class="text-body-2 pa-0 mb-1">
            <div class="d-flex w-100">
              <div class="text-left">
                <b>Antigüedad:</b> <br />
                IUSA: {{ seniorityIUSA }}
              </div>
            </div>
          </div>
          <!-- icons bar -->
          <div class="pa-0 mb-1 ml-auto">
            <div class="w-100 d-flex justify-center">
              <a @click="loadMap()">
                <svg-icon name="maps-icon" size="25" />
              </a>
              <sales-policy-file-downloader
                class="mx-1"
                icon-size="25"
                policy-type="car"
                :icon-class="
                  data.hasCar ? 'car-policy-enabled' : 'car-policy-disabled'
                "
              />
              <sales-policy-file-downloader
                icon-size="25"
                policy-type="delivery"
              />
              <sales-policy-file-downloader
                icon-size="25"
                class="mx-1"
                policy-type="sellCredit"
              />
              <i-u-s-a-training
                label="Iusa capacita"
                class="mt-n2"
                :user-id="data.user.id"
                size="40"
              />
            </div>
            <!-- population content -->

            <div class="d-flex justify-end">
              <sales-per-capita
                :chnl="chnl"
                :user-code="fillNumberToNDigits(data.user.id, 8)"
                :scope="data.user?.isTerritorial ? 'territorial' : 'director'"
                :billed-amount="Number(data.billingLastMonth)"
              />
            </div>
            <!-- end population content -->
          </div>
          <!-- end icons bar-->
        </div>
      </div>
      <alert-prominent v-if="error" :message="error" :with-action="true" />
    </v-card>
    <!-- modals -->
    <customer-locations-map
      v-model="openMap"
      :type="typeCustomerLocation"
      :customers="customersLocation"
    />
  </div>
</template>
<script>
  import moment from 'moment';
  import axios from '@/plugins/axios';
  import MixinHelpers from '@/mixins/helpers';
  import MixinGlobal from '@/mixins/global';
  import numbersFormats from '@/mixins/numbersFormats';
  import dates from '@/mixins/dates';
  import { MetaRoles } from '@/core/constants/roleConstants';
  import CustomerLocationsMap from '@/components/modals/customers_locations_map/CustomerLocationsMap.vue';
  import SalesPolicyFileDownloader from '@/components/policies/SalesPolicyFileDownload.vue';
  import AlertProminent from '@/components/AlertProminent.vue';
  import SvgIcon from '@/components/icons/SvgIcon.vue';
  import IUSATraining from '@/components/icons/IUSATraining.vue';
  import SalesPerCapita from '@/views/daily/components/SalesPerCapita.vue';
  export default {
    name: 'DirectorCard',
    components: {
      AlertProminent,
      CustomerLocationsMap,
      SalesPolicyFileDownloader,
      SvgIcon,
      IUSATraining,
      SalesPerCapita,
    },
    mixins: [numbersFormats, MixinHelpers, MixinGlobal, dates],
    props: {
      data: {
        type: Object,
        default: () => ({}),
      },
      error: {
        type: String,
        default: '',
      },
      user: {
        type: String,
        required: true,
      },
      chnl: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data: () => ({
      customersLocation: [],
      today: moment().format('YYYY-MM-DD'),
      openMap: false,
      typeCustomerLocation: 'bydirector',
    }),
    computed: {
      isRM() {
        return this.$route.meta.role === MetaRoles.RegionalManager;
      },
      seniorityIUSA() {
        if (this.data.seniority) {
          return this.countMonthsUpToToday(this.data.seniority, 'YYYY-MM-DD')
            .text.text;
        }
        return 'N/A';
      },
    },
    watch: {
      openMap() {
        if (!this.openMap) {
          this.customersLocation = [];
        }
      },
    },
    methods: {
      async getCustomersLocation(type = '', employeeNumber) {
        try {
          this.openMap = true;
          let response = await axios.get(
            '/geolocation-map/coordinates-customers',
            {
              params: {
                inicio: this.today,
                fin: this.today,
                P_VTWEG: this.chnl,
                P_VKORG: this.user?.VKORG ?? 'IUS2',
                employee_number: employeeNumber,
                type: type,
              },
            }
          );
          this.customersLocation = response.data;
        } catch (error) {
          this.openMap = false;
          this.$swal(
            'Ups',
            'No se han podido obtener las geolocalizaciones',
            'error'
          );
        }
      },
      loadMap() {
        this.isRM
          ? this.getCustomersLocation('byRegionalManager', this.user)
          : this.getCustomersLocation('byDirector');
      },
    },
  };
</script>
